// extracted by mini-css-extract-plugin
export default {"pastIcon":"PegInStepsBar_pastIcon__zRQY3","failedIcon":"PegInStepsBar_failedIcon__InRrG"};